import React, { useContext } from 'react';

//============== COMPONENTES ==============
import {
    Button,
    Grid,
    Skeleton,
    Typography,
    Box,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import fondo from '../../../../utils/img/header-bg.jpg';
import { HomeContext } from '../../../Providers/HomeContext';
import { keyframes } from '@mui/system';

//============== ANIMACIONES ==============
const fadeInUp = keyframes`
    from {
        opacity: 0;
        transform: translateY(30px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

const pulse = keyframes`
    0%, 100% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.05);
    }
`;

const shimmer = keyframes`
    0% {
        background-position: -1000px 0;
    }
    100% {
        background-position: 1000px 0;
    }
`;

//============== ESTILOS MUI ==============
const useStyles = makeStyles((theme) => ({
    container: {
        height: '80vh',
        backgroundImage: `url(${fondo})`,
        backgroundSize: 'cover',
        objectFit: 'cover',
        backgroundPosition: 'center',
        position: 'relative',
        overflow: 'hidden',

    },
    curtine: {
        background: 'rgba(20,20,20,0.7)',
        height: '100%',
        width: '100%',
        justifyContent: 'center',
        backdropFilter: 'blur(2px)',
        position: 'relative',
        [theme.breakpoints.down('sm')]: {
            justifyContent: 'start',
            paddingTop: '80px',
        },
    },
    txtPrimary: {
        color: '#ffffff',
        fontWeight: 300,
        letterSpacing: '0.05em',
        textTransform: 'uppercase',
        marginBottom: '4px',
        textShadow: '0 2px 10px rgba(0,0,0,0.5)',
        animation: `${fadeInUp} 1s ease-out`,
    },
    txtSecondary: {
        color: '#ffffff',
        fontWeight: 700,
        letterSpacing: '0.01em',
        marginBottom: '32px',
        fontSize: '3.5rem',
        textShadow: '0 4px 20px rgba(0,0,0,0.7)',
        animation: `${fadeInUp} 1s ease-out 0.2s backwards`,
        [theme.breakpoints.down('md')]: {
            fontSize: '2.5rem',
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '2rem',
        },
    },
    btnPdfNqn: {
        backgroundColor: theme.palette.btn.main,
        color: '#ffffff',
        padding: '12px 28px',
        borderRadius: '8px',
        fontWeight: 600,
        fontSize: '0.9rem',
        letterSpacing: '0.3px',
        textTransform: 'uppercase',
        boxShadow: '0 4px 12px rgba(44,120,37,0.3)',
        transition: 'all 0.3s ease',
        '&:hover': {
            backgroundColor: theme.palette.btn.hover,
            transform: 'translateY(-2px)',
            boxShadow: '0 3px 10px rgba(38, 105, 32, 0.4)',
        },
    },
    btnPdfCipo: {
        backgroundColor: theme.palette.btn.main,
        color: '#ffffff',
        padding: '12px 28px',
        borderRadius: '8px',
        fontWeight: 600,
        fontSize: '0.9rem',
        letterSpacing: '0.3px',
        textTransform: 'uppercase',
        boxShadow: '0 4px 12px rgba(44,120,37,0.3)',
        transition: 'all 0.3s ease',
        '&:hover': {
            backgroundColor: theme.palette.btn.hover,
            transform: 'translateY(-2px)',
            boxShadow: '0 3px 10px rgba(38, 105, 32, 0.4)',
        },
    },
    skeleton: {
        width: 200,
        padding: "22px 0",
        backgroundColor: '#2c7825',
        borderRadius: '8px',
    },
    btnFormWork: {
        backgroundColor: '#f29400',
        color: '#ffffff',
        padding: '12px 28px',
        borderRadius: '8px',
        fontWeight: 600,
        fontSize: '0.9rem',
        letterSpacing: '0.3px',
        textTransform: 'uppercase',
        boxShadow: '0 4px 12px rgba(242,148,0,0.3)',
        transition: 'all 0.3s ease',
        '&:hover': {
            backgroundColor: '#de8700',
            transform: 'translateY(-2px)',
            boxShadow: '0 3px 10px rgba(242,148,0,0.4)',
        },
    },
    btnSecondary: {
        backgroundColor: 'rgba(255,255,255,0.1)',
        color: '#ffffff',
        padding: '12px 28px',
        borderRadius: '8px',
        fontWeight: 600,
        fontSize: '0.9rem',
        letterSpacing: '0.3px',
        textTransform: 'uppercase',
        border: '1px solid rgba(255,255,255,0.2)',
        boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
        transition: 'all 0.3s ease',
        '&:hover': {
            backgroundColor: 'rgba(255,255,255,0.2)',
            transform: 'translateY(-2px)',
            boxShadow: '0 6px 16px rgba(0,0,0,0.3)',
        },
    },
    contentWrapper: {
        position: 'relative',
        zIndex: 2,
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 20px',
    },
    divider: {
        width: '60px',
        height: '3px',
        backgroundColor: theme.palette.btn.main,
        margin: '12px auto 20px',
        borderRadius: '2px',
    },
}));

const {
    REACT_APP_URL_STORAGE,
} = process.env;


const InicioV = (/*{abrirPostulaciones}*/) => {

    //======= CONTEXTOS =======
    const { urlInstructive, urlInstructiveNqn } = useContext(HomeContext);

    //======= VARIABLE ESTILOS =======
    const classes = useStyles();

    //======= Funcion que lleva a el instructivo =======
    const openInstructive = (type) => {
        let pdfUrl = '';
        if (type === 'nqn') {
            pdfUrl = REACT_APP_URL_STORAGE + urlInstructiveNqn;
        } else if (type === 'cipo') {
            pdfUrl = REACT_APP_URL_STORAGE + urlInstructive;
        }
        window.open(pdfUrl, '_blank');
        return;
    };

    //======= VISTA =======
    return (
        <Grid item container className={classes.container} align="center" alignContent='center' id='inicio'>
            <Grid item container direction='column' className={classes.curtine}>
                <Box className={classes.contentWrapper}>
                    <Grid item data-aos="fade-right" data-aos-duration="1500">
                        <Typography variant='h6' className={classes.txtPrimary}>
                            Querés Manejar?
                        </Typography>
                    </Grid>
                    <Box className={classes.divider} data-aos="fade-in" data-aos-duration="1500" data-aos-delay="300" />
                    <Grid item data-aos="fade-right" data-aos-duration="1500">
                        <Typography className={classes.txtSecondary}>
                            SACÁ TU CARNET DE CONDUCIR
                        </Typography>
                    </Grid>
                    <Grid item container spacing={2} justifyContent="center" data-aos="fade-up" data-aos-duration="1500" marginBottom={2.5}>
                        <Grid item>
                            {urlInstructive ? (
                                <Button
                                    variant="contained"
                                    size="large"
                                    className={classes.btnPdfCipo}
                                    onClick={() => openInstructive('cipo')}
                                >
                                    {window.screen.width > 600 ? 'VER INSTRUCTIVO CIPOLLETTI' : 'INSTRUCTIVO CIPOLLETTI'}
                                </Button>
                            ) :
                                (
                                    <Skeleton variant="rounded" className={classes.skeleton} />
                                )
                            }
                        </Grid>
                        <Grid item>
                            {urlInstructive ? (
                                <Button
                                    variant="contained"
                                    size="large"
                                    className={classes.btnPdfNqn}
                                    onClick={() => openInstructive('nqn')}
                                >
                                    {window.screen.width > 600 ? 'VER INSTRUCTIVO NEUQUÉN' : 'INSTRUCTIVO NEUQUÉN'}
                                </Button>
                            ) :
                                (
                                    <Skeleton variant="rounded" className={classes.skeleton} />
                                )
                            }
                        </Grid>
                    </Grid>
                    <Grid item container spacing={2} justifyContent="center" data-aos="fade-up" data-aos-duration="1500" data-aos-delay="200">
                        <Grid item>
                            <Button
                                variant="contained"
                                size="large"
                                className={classes.btnSecondary}
                                href="#curses"
                            >
                                VER CURSOS
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button
                                variant="contained"
                                size="large"
                                className={classes.btnFormWork}
                                href="#formwork"
                            >
                                FORMA PARTE DE NUESTRO STAFF
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </Grid>
        </Grid >
    )
}

export default InicioV